import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import LabelWithIcon from '@/app/components/search/components/Card/Details/Badges/LabelWithIcon';
import { useTranslation } from '@/app/components/translations/Translation';
import { getActivePeriodicPromotion, PERIODIC_PROMOTION_LABEL_KEYS } from '@/app/common/periodicPromotions';

/**
 * Renders the badge for the current promotional period, if any
 */
export function PeriodicPromotion() {
  const { t } = useTranslation();
  const {
    localization,
    commonData: { serverTime },
  } = usePageWrapperData();

  const activePromotion = getActivePeriodicPromotion(serverTime, localization);
  if (!activePromotion) return null;

  const promotionLabelKey = PERIODIC_PROMOTION_LABEL_KEYS[activePromotion];
  if (!promotionLabelKey) return null;

  return <LabelWithIcon label={t(promotionLabelKey)} promotionType={activePromotion} />;
}
